import WebService from "../../Services/WebServices";

// region Home content APIs
export const getHomeContent = () => {
    return WebService.getSharedInstance().callWebservice({ method: "GET", path: `/home-content` });
};

export const patchHomeContent = (data) => {
    const id = data.get("id");
    data.delete("id");

    return WebService.getSharedInstance().callWebservice({
        method: "PATCH",
        path: `/home-content/${id}`,
        data: data,
        isFormData: true
    });
};
// endregion

// region Partner content APIs
export const getPartnerContent = () => {
    return WebService.getSharedInstance().callWebservice({
        method: "GET",
        path: `/partner-content`
    });
};

export const postPartnerContent = (data) => {
    return WebService.getSharedInstance().callWebservice({
        method: "POST",
        path: `/partner-content`,
        data: data,
        isFormData: true
    });
};

export const deletePartnerContent = (id) => {
    return WebService.getSharedInstance().callWebservice({
        method: "DELETE",
        path: `/partner-content/${id}`,
        isFormData: true
    });
};


export const patchPartnerContent = (data) => {
    const id = data.get("id");
    data.delete("id");

    return WebService.getSharedInstance().callWebservice({
        method: "PATCH",
        path: `/partner-content/${id}`,
        data: data,
        isFormData: true
    });
};
// endregion

// region Driver content APIs
export const getDriverContent = () => {
    return WebService.getSharedInstance().callWebservice({ method: "GET", path: `/driver-content` });
};

export const patchDriverContent = (data) => {
    return WebService.getSharedInstance().callWebservice({
        method: "PATCH",
        path: `/driver-content/${data.id}`,
        data: data,
        isFormData: false
    });
};

export const getDriverListContent = () => {
    return WebService.getSharedInstance().callWebservice({ method: "GET", path: `/driver-partner-content` });
};


export const deleteDriverListContent = (id) => {
    return WebService.getSharedInstance().callWebservice({ method: "DELETE", path: `/driver-partner-content/${id}` });
};

export const patchDriverListContent = (data) => {
    const id = data.get("id");

    return WebService.getSharedInstance().callWebservice({
        method: "PATCH",
        path: `/driver-partner-content/${id}`,
        data: data,
        isFormData: true,
    });
};

export const postDriverListContent = (data) => {
    return WebService.getSharedInstance().callWebservice({
        method: "POST",
        path: `/driver-partner-content`,
        data: data,
        isFormData: true,
    });
};

// endregion

// region Vehicle content APIs
export const getVehicleContent = () => {
    return WebService.getSharedInstance().callWebservice({ method: "GET", path: `/vehicle-content` });
};

export const getVehicleListContent = () => {
    return WebService.getSharedInstance().callWebservice({ method: "GET", path: `/vehicle-partner-content` });
};

export const deleteVehicleListContent = (id) => {
    return WebService.getSharedInstance().callWebservice({ method: "DELETE", path: `/vehicle-partner-content/${id}` });
};

export const patchVehicleContent = (data) => {
    return WebService.getSharedInstance().callWebservice({
        method: "PATCH",
        path: `/vehicle-content/${data.id}`,
        data: data,
    });
};

export const patchVehicleListContent = (data) => {
    const id = data.get("id");

    return WebService.getSharedInstance().callWebservice({
        method: "PATCH",
        path: `/vehicle-partner-content/${id}`,
        data: data,
        isFormData: true,
    });
};

export const postVehicleListContent = (data) => {
    return WebService.getSharedInstance().callWebservice({
        method: "POST",
        path: `/vehicle-partner-content`,
        data: data,
        isFormData: true,
    });
};
// endregion
